<template>
  <maintenance v-if="user.maintenance_mode && user.access < 6"/>
  <div class="admin-app" v-else>
    <page-header></page-header>
    <div class="clearfix"></div>
    <div class="page-container">
      <page-sidebar></page-sidebar>
      <div class="page-content-wrapper">
        <div class="page-content">
          <transition name="fade">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
    <session-timeout-modal :seconds-to-session-end="secondsToSessionEnd" @logout="logout" @refresh="refreshAction" />
  </div>
</template>
<script>
  import Sidebar from '../components/menu/Sidebar.vue';
  import Header from '../components/menu/Header.vue';
  import Footer from '../components/menu/Footer.vue';
  import {HTTP} from '@/http-common';
  import auth from '@/auth'
  import {mapActions, mapGetters} from 'vuex';
  import Maintenance from "./Maintenance";
  import sessionEndHandler from "../mixins/sessionEndHandler";

  export default {
    name: 'admin-app',
    mixins: [sessionEndHandler],
    components: {
      'page-sidebar': Sidebar,
      'page-header': Header,
      'page-footer': Footer,
      'maintenance': Maintenance
    },

    data() {
      return {
        idleTime: 60, //time in seconds to check session
        idleCountdown: null,
        idleTimeout: false
      }
    },
    computed: {
      ...mapGetters({
        user: 'getUser'
      })
    },
    methods: {
      ...mapActions([
        'checkAuth',
        'GET_USER_DATA_REFRESH_ACTION',
        'setIsSessionUpdatePending'
      ]),
      refreshAction(){
        this.setIsSessionUpdatePending(true)
        this.GET_USER_DATA_REFRESH_ACTION(null).then( _res => {
          this.idleReset();
          this.checkAuth();
        })
      },
      startIdleCountdown: function () {
        this.idleCountdown = this.idleTime;
        this.setIdleTimer = setInterval(this.idleTimer, 1000);
      },

      idleTimer: function () {
        this.idleCountdown = this.idleCountdown - 1;

        if (!this.idleCountdown) {
          clearInterval(this.setIdleTimer);
          this.idleTimeout = !this.idleTimeout;
        }
      },

      idleReset: function () {
        clearInterval(this.setIdleTimer);
        this.startIdleCountdown();
      },

      logout() {
        auth.logout();
      }

    },

    mounted() {
      Layout.init();
      this.startIdleCountdown();
      auth.checkAuth();
      this.checkAuth();
    },

    watch: {

      '$route': function () {
        auth.checkAuth();
      },

      'idleCountdown': function () {

        if (this.idleCountdown <= 0) {


          this.idleReset();

          this.checkAuth();
//
//          HTTP.post(`users/check`, localStorage.getItem('id_token'))
//            .then(response => {
//              if(response.data.status == 'error') {
//                auth.lock();
//              }
//            }).catch(err => {
//              console.log(err);
//            });

        }
      }
    }
  }
</script>
<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .3s;
  }

  .fade-enter-active {
    transition-delay: .3s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .to-logout {
    position: fixed;
    left: 11px;
    bottom: 35px;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// Admin.vue?a352d988